var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btx-ck-editor"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"disabled":_vm.disabled,"value":_vm.editorData,"config":_vm.editorConfig},on:{"input":_vm.onInput,"change":_vm.onInput,"ready":function($event){_vm.editorReady = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }